<template>
  <v-textarea ref="campo"
    v-model="model"
    v-bind="attrs"
    :label="labelDefault"
    :rules="rules"
    :rows="rows"
    v-on="$listeners"
    :data-cy="attrs.label || attrs.name">
  <template v-for="(_, slotName) in $scopedSlots" v-slot:[slotName]="context">
    <slot :name="slotName" v-bind="context" />
  </template>
    <template v-for="(_, name) in $slots" v-slot:[name]>
      <slot :name="name" />
    </template>
    <template v-if="!$scopedSlots.message" v-slot:message="{ message, key }">
      <v-icon v-if="$api.UI.showErrorIcon($el)" x-small color="error" class="mr-1 pb-1">{{$theme.options.iconError}}</v-icon>
      <span v-html="message" :key="key"></span>
    </template>
  </v-textarea>
</template>
<script>
export default {
  props: {
    value: String,
    change: Function,
    rows: { Type: String, default: '2' }
  },
  computed: {
    toUpperCase: function () {
      return localStorage.upperCaseForm === 'S'
    },
    labelDefault: function () {
      return (
        this.$attrs.label ? this.$attrs.label +
        (this.$attrs.required === '' || this.$attrs.required === true ? ' *' : '')
          : ''
      )
    },
    model: {
      get () {
        if (this.toUpperCase && this.value && this.$el && typeof this.value === 'string') {
          var input = this.$el.querySelector('textarea')
          const p = input.selectionStart
          this.$nextTick(() => {
            input.setSelectionRange(p, p);
          })
          return this.value.toUpperCase()
        }
        return this.value
      },
      set (value) {
        if (value && typeof value === 'string') { this.$emit('input', this.toUpperCase ? value.toUpperCase() : value) } else { this.$emit('input', value) }
      }
    },
    attrs () {
      return { ...this.$theme.options, ...this.$theme.options.textarea, ...this.$attrs }
    },
    rules () {
      const errors = []
      const name = this.$attrs.name || this.$attrs.label || ''
      if (this.$attrs.required === '' || this.$attrs.required === true) {
        !!this.model || errors.push(name + ' é obrigatório.')
      }

      if (this.$attrs.counter) {
        (this.model ? this.model : '').toString().length <=
          this.$attrs.counter ||
          errors.push(
            name + ' deve ter até ' + this.$attrs.counter + ' caracteres.'
          )
      }

      if (this.$refs && this.$refs.campo && this.$refs.campo.$el) {
        this.$refs.campo.$el.setAttribute(
          'data-message',
          errors ? errors[0] : ''
        )
        this.$refs.campo.$el.setAttribute('data-invalid', errors.length > 0)
      }

      return errors
    }
  },
  mounted () {
    this.$nextTick(function () {
      const errors = this.rules
      this.$el.setAttribute('data-message', errors ? errors[0] : '')
      this.$el.setAttribute('data-invalid', errors.length > 0)
    })
  }
}
</script>
